define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/RoleGroupModel"], function (require, exports, $, ko, log, tools, RoleGroupModel) {
    "use strict";
    var RoleGroupActions = /** @class */ (function () {
        function RoleGroupActions() {
            this.editModel = ko.observable(new RoleGroupModel());
        }
        RoleGroupActions.prototype.init = function () {
        };
        RoleGroupActions.prototype.editRoleGroup = function (theId, name, duplicate) {
            var self = this;
            var title = "Add Role";
            if ($.isNumeric(theId) && name) {
                title = "Edit Role " + name + " Details";
            }
            if (duplicate) {
                title = "Add Role (duplicate)";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name Address is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveRoleGroup(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if ($.isNumeric(theId)) {
                        getModelCall = tools.ajaxGet({
                            url: "/RoleGroup/GetById",
                            data: {
                                id: theId,
                                duplicate: duplicate === true
                            },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new RoleGroupModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new RoleGroupModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'role-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        $(".roles-holder", modal).kendoTooltip({
                            filter: "label",
                            position: "top"
                        }).data("kendoTooltip");
                        $(".roles-name", modal).kendoTooltip({
                            filter: "label",
                            content: function (e) {
                                var target = e.target;
                                var roleId = $(target).data("id");
                                var roleObject = ko.utils.arrayFirst(self.editModel().PermissionGroups(), function (item) {
                                    return item.Name() === roleId;
                                });
                                if (roleObject) {
                                    return roleObject.MainDescription();
                                }
                                return target.text();
                            }
                        });
                    });
                }
            });
        };
        RoleGroupActions.prototype.saveRoleGroup = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            ko.utils.arrayForEach(obj.PermissionGroups, function (item) {
                delete item.MainDescription;
            });
            var data = {
                Id: obj.Id,
                Name: obj.Name,
                Description: obj.Description,
                permissionGroups: JSON.stringify(obj.PermissionGroups),
                __RequestVerificationToken: $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val()
            };
            tools.ajaxPost({
                url: "/RoleGroup/SaveRole",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (_this.saveCallback) {
                        _this.saveCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        RoleGroupActions.prototype.deleteRoleGroupConfirm = function (theId, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Role - " + name,
                text: "Are you sure you want to Delete Role?",
                buttonTitle: "Remove",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteRoleGroup(theId);
            });
        };
        RoleGroupActions.prototype.deleteRoleGroup = function (theId) {
            var self = this;
            var data = {
                id: theId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/RoleGroup/DeleteRoleGroupConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Role deleted successfully");
                    if (self.deleteCallback) {
                        self.deleteCallback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        return RoleGroupActions;
    }());
    return RoleGroupActions;
});
//# sourceMappingURL=role-group-actions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/roleGroup/role-group-actions.js
// module id = 283
// module chunks = 2